var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttention = function SvgAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.667 8a.667.667 0 0 1-1.334 0V5.333a.667.667 0 1 1 1.334 0V8ZM7.333 10.667a.667.667 0 1 1 1.334 0 .667.667 0 0 1-1.334 0Z",
    fill: "#D0DF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.567 1.75a.5.5 0 0 1 .866 0l6.062 10.5a.5.5 0 0 1-.432.75H1.937a.5.5 0 0 1-.432-.75l6.062-10.5Z",
    stroke: "#D0DF00"
  })));
};
export default SvgAttention;